// Edición real de fotos: el resultado se guarda en el archivo, así se ve igual en toda la app.
export const OVERLAY_FONT_RATIO = 0.06;
const OVERLAY_MAX_WIDTH_RATIO = 0.9;
const OVERLAY_LINE_HEIGHT = 1.2;

export const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });

const wrapLines = (context, text, maxWidth) => {
  const lines = [];
  text.split("\n").forEach((paragraph) => {
    let line = "";
    paragraph.split(" ").forEach((word) => {
      const candidate = line ? `${line} ${word}` : word;
      if (line && context.measureText(candidate).width > maxWidth) {
        lines.push(line);
        line = word;
      } else {
        line = candidate;
      }
    });
    lines.push(line);
  });
  return lines;
};

const drawOverlay = (context, overlay, width, height) => {
  const fontSize = width * OVERLAY_FONT_RATIO;
  context.font = `800 ${fontSize}px Roboto, Arial, sans-serif`;
  context.textAlign = "center";
  context.textBaseline = "middle";
  context.fillStyle = overlay.color;
  context.shadowColor = overlay.color === "#000000" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.75)";
  context.shadowBlur = fontSize * 0.2;
  const lines = wrapLines(context, overlay.text, width * OVERLAY_MAX_WIDTH_RATIO);
  const lineHeight = fontSize * OVERLAY_LINE_HEIGHT;
  const centerX = (overlay.x / 100) * width;
  const firstY = (overlay.y / 100) * height - ((lines.length - 1) * lineHeight) / 2;
  lines.forEach((line, index) => context.fillText(line, centerX, firstY + index * lineHeight));
  context.shadowBlur = 0;
};

export const renderImage = (image, { rotation = 0, aspect = null, filterCss = "none", overlays = [], maxSide = 1600 }) => {
  const sourceWidth = image.naturalWidth;
  const sourceHeight = image.naturalHeight;
  const swapped = rotation % 180 !== 0;
  const rotatedWidth = swapped ? sourceHeight : sourceWidth;
  const rotatedHeight = swapped ? sourceWidth : sourceHeight;

  // El recorte queda centrado sobre la imagen ya girada.
  let cropWidth = rotatedWidth;
  let cropHeight = rotatedHeight;
  if (aspect) {
    if (rotatedWidth / rotatedHeight > aspect) cropWidth = rotatedHeight * aspect;
    else cropHeight = rotatedWidth / aspect;
  }

  const scale = Math.min(1, maxSide / Math.max(cropWidth, cropHeight));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(cropWidth * scale);
  canvas.height = Math.round(cropHeight * scale);
  const context = canvas.getContext("2d");

  context.save();
  context.filter = filterCss;
  context.translate(canvas.width / 2, canvas.height / 2);
  context.rotate((rotation * Math.PI) / 180);
  context.scale(scale, scale);
  context.drawImage(image, -sourceWidth / 2, -sourceHeight / 2);
  context.restore();

  overlays.forEach((overlay) => drawOverlay(context, overlay, canvas.width, canvas.height));
  return canvas;
};

export const canvasToJpeg = (canvas) =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("No se pudo generar la imagen"))), "image/jpeg", 0.9);
  });
